import { render } from "./Afterservice.vue?vue&type=template&id=0ee8f64b&scoped=true"
import script from "./Afterservice.vue?vue&type=script&lang=js"
export * from "./Afterservice.vue?vue&type=script&lang=js"

import "./Afterservice.vue?vue&type=style&index=0&id=0ee8f64b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee8f64b"]])

export default __exports__